// extracted by mini-css-extract-plugin
export default {"tupacGrid":"jm-z","tupacHeader":"km-z","tupacHeader2":"lm-z","tupacMenu":"mm-z","tupacMenu2":"nm-z","tupacMain":"om-z","tupacMain2":"pm-z"};